module.exports = __webpack_public_path__ + "img/3.253c206d.png";